import { IconSignature } from '@tabler/icons-react'
import { Rule } from 'antd/lib/form'
import styled from 'styled-components'

import { SignatureCaptureBlock as RenderSignatureCaptureBlock } from '../../templateRenderer/CaptureBlocks/SignatureCaptureBlock'
import { SignatureDisplayBlock as RenderSignatureDisplayBlock } from '../../templateRenderer/DisplayBlocks/SignatureDisplayBlock'
import {
  SignatureCaptureBlock,
  SignatureDisplayBlock,
} from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  FORBIDDEN_IN_APP,
  TypeOption,
} from './_BaseBlockConfig'

import { SignatureData } from '@/components/form-components/SignatureAttachmentUploader'
import { Text } from '@/components/shared-components/BUI/Text'
import { Flexbox } from '@/components/shared-components/Flexbox'

const ColumnImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  object-fit: contain;
`

class Config extends BaseBlockConfig<SignatureCaptureBlock> {
  public override kind = 'capture' as const
  public override type = 'signature' as const

  public override enableAdminOnlyVisiblity = true
  public override enableBlockToColumnDisplay = true

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Signature',
    icon: IconSignature,
    helpText: 'Capture a signature and name',
    forbiddenTemplateTypes: FORBIDDEN_IN_APP,
  }

  public override blockFieldsConfig: Field[] = []

  public override mapFormValueToBlock(
    block: SignatureCaptureBlock,
    value: SignatureData
  ): SignatureCaptureBlock {
    return {
      ...block,
      signeeName: value?.signee,
      ...(value?.attachmentId && {
        attachmentId: value?.attachmentId,
        key: value?.key,
        time: new Date(value?.time)?.toISOString(),
      }),
    }
  }

  public override mapBlockToColumnDisplay(
    block: SignatureCaptureBlock
  ): React.ReactNode {
    const { signeeName, url } = block

    if (!signeeName && !url) return null

    return (
      <Flexbox flexDirection="column" alignItems="center" gap="1rem">
        <ColumnImage alt={signeeName} src={url} />
        {signeeName && (
          <Text variant="caption01" align="right">
            {signeeName}
          </Text>
        )}
      </Flexbox>
    )
  }

  public override renderBlock(
    block: SignatureCaptureBlock,
    rules?: Rule[]
  ): React.ReactNode {
    return <RenderSignatureCaptureBlock block={block} rules={rules} />
  }

  public override renderDisplayBlock(
    block: SignatureDisplayBlock
  ): React.ReactNode {
    return <RenderSignatureDisplayBlock block={block} />
  }
}

export const SignatureCaptureBlockConfig = new Config()
